import React from 'react';
import PageHeader from '../components/PageHeader';
import AboutSection from '../components/AboutSection';
import AboutDeepDive from '../components/AboutDeepDive';
import CTABoxes from '../components/CTABoxes';

const AboutPage = () => {
  return (
    <>
      <PageHeader
        eyebrow="About Us"
        title="Melbourne's Trusted Plumbing & Roofing Specialists"
        description="Licensed, insured, and 5-star rated — serving Melbourne with quality workmanship for over 15 years."
      />
      <AboutSection />
      <AboutDeepDive />
      <CTABoxes />
    </>
  );
};

export default AboutPage;
